//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

export const RegistrationPersonFieldType = {
    /** The first name */
    FirstName: 0,

    /** The last name */
    LastName: 1,

    /** The person's campus */
    Campus: 2,

    /** The Address */
    Address: 3,

    /** The email */
    Email: 4,

    /** The birthdate */
    Birthdate: 5,

    /** The gender */
    Gender: 6,

    /** The marital status */
    MaritalStatus: 7,

    /** The mobile phone */
    MobilePhone: 8,

    /** The home phone */
    HomePhone: 9,

    /** The work phone */
    WorkPhone: 10,

    /** The grade */
    Grade: 11,

    /** The connection status */
    ConnectionStatus: 12,

    /** The middle name */
    MiddleName: 13,

    /** The anniversary date */
    AnniversaryDate: 14,

    /** The race */
    Race: 15,

    /** The ethnicity */
    Ethnicity: 16
} as const;

export const RegistrationPersonFieldTypeDescription: Record<number, string> = {
    0: "First Name",

    1: "Last Name",

    2: "Campus",

    3: "Address",

    4: "Email",

    5: "Birthdate",

    6: "Gender",

    7: "Marital Status",

    8: "Mobile Phone",

    9: "Home Phone",

    10: "Work Phone",

    11: "Grade",

    12: "Connection Status",

    13: "Middle Name",

    14: "Anniversary Date",

    15: "Race",

    16: "Ethnicity"
};

export type RegistrationPersonFieldType = typeof RegistrationPersonFieldType[keyof typeof RegistrationPersonFieldType];
